import { render, staticRenderFns } from "./recyclingBinView.vue?vue&type=template&id=34f0e51c&scoped=true"
import script from "./recyclingBinView.vue?vue&type=script&lang=js"
export * from "./recyclingBinView.vue?vue&type=script&lang=js"
import style0 from "./recyclingBinView.vue?vue&type=style&index=0&id=34f0e51c&prod&lang=scss&scoped=true"
import style1 from "./recyclingBinView.vue?vue&type=style&index=1&id=34f0e51c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f0e51c",
  null
  
)

export default component.exports